/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Minimal internal response; never exposes tenant integration or billing details.
 */
export type SenderAvailabilityResponse = {
    /**
     * Connection state only; provider errors propagate instead of granting availability.
     */
    state: SenderAvailabilityResponse.state;
};
export namespace SenderAvailabilityResponse {
    /**
     * Connection state only; provider errors propagate instead of granting availability.
     */
    export enum state {
        AVAILABLE = 'available',
        UNAVAILABLE = 'unavailable',
        UNSUPPORTED = 'unsupported',
    }
}

